import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';

export const clearAll = createAction(addNamespace('global/clearAll'));
